<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 dialog-heading">Payment</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full h-[900px]">
        <iframe [src]="this.safeUrl" class="w-full h-full" frameborder="0"></iframe>
    </div>
</mat-dialog-content>